<template lang="pug">
  #visited-index.grid-scroll-more(v-if="!loading" v-scrolled-to-end="fetchMore")
    PageHeader(headerText="Visited" :sortOptions="sortOptions" @sortBy="setSortOrder" )
    GridDisplay(:entities="users")
</template>

<script>
import { mapState } from 'vuex'
import fetchAndSort from '@/mixins/fetchAndSort'

export default {
  mixins: [fetchAndSort],
  props: {},

  data() {
    return {
      fetchType: 'users/fetchVisited',
      loading: true,
      sortOrder: 'recent',
      sortOptions: ['recent', 'most visits'],
    }
  },

  computed: {
    ...mapState({
      users: state => state.users.users,
    }),
  },

  watch: {},

  async created() {
    await this.fetchRecords()
    this.loading = false
  },

  methods: {},

  components: {
    GridDisplay: require('@/components/GridDisplay').default,
    PageHeader: require('@/components/PageHeader').default,
  },
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
